package nl.astraeus.midi.audio

object AudioContextHandler {
  val audioContext: dynamic = js("new AudioContext()")
}
